module.exports = __webpack_public_path__ + "static/truck2-6700707fc6bad2693378e2de74a9a356.png";